import React from 'react';

const OpenSourceContributionPage = () => {
  return (
    <div className="bg-gray-100 p-6">
      <div className="container mx-auto">
        <h1 className="text-3xl font-semibold mb-6">Open Source Contribution</h1>
        <p className="text-lg mb-6">
          Learnsource is an open-source project, and we welcome contributions from technical enthusiasts like you. Your contributions play a vital role in enhancing our platform and making quality education accessible to all.
        </p>
        <p className="text-lg mb-6">
          To ensure a smooth and collaborative contribution process, we have established a set of GitHub Contribution Guidelines for our project. Please review these guidelines carefully before raising issues, making pull requests (PRs), or contributing in any other way.
        </p>
        <h2 className="text-2xl font-semibold mb-4">GitHub Contribution Guidelines</h2>
        <p className="text-lg mb-6">
          1. **Raising Issues:** If you encounter a bug, have an idea for an improvement, or wish to discuss any aspect of the project, please create an issue on our GitHub repository. Be sure to provide clear and concise details about the problem or suggestion.
        </p>
        <p className="text-lg mb-6">
          2. **Making Pull Requests (PRs):** We encourage you to submit PRs for bug fixes, feature enhancements, or other contributions. Before creating a PR, ensure that your code aligns with our project's coding standards and conventions. Clearly describe the purpose of your PR and the changes it introduces.
        </p>
        <p className="text-lg mb-6">
          3. **Code of Conduct:** Please adhere to our project's Code of Conduct, which promotes a respectful and inclusive environment. Discriminatory behavior and harassment will not be tolerated.
        </p>
        <p className="text-lg mb-6">
          4. **Collaboration:** Be open to collaboration and feedback from other contributors. Respect the opinions and ideas of fellow community members as we work together to improve Learnsource.
        </p>
        <p className="text-lg mb-6">
          5. **License:** Ensure that your contributions comply with our project's open-source license, and confirm that you have the right to contribute the code.
        </p>
        <p className="text-lg mb-6">
          To start contributing, visit our [GitHub repository](https://github.com/learnsource) and explore the existing issues, PRs, and documentation. We look forward to your contributions and appreciate your commitment to making quality education accessible to all.
        </p>
      </div>
    </div>
  );
};

export default OpenSourceContributionPage;
